import React from "react";
import { Rating as MUIRating, RatingProps } from "@mui/material";

const Rating: React.FC<RatingProps> = (props) => {
    return <MUIRating {...props} />;
};

export default Rating;
